module.exports = __webpack_public_path__ + "img/waistband_width.2a7800ef.png";